import { apolloCacheConfig } from '@crehana/apollo-client';

/**
 * ANLT-669 — `Query.certificate_template` returns `CertificateBuilderQuery`,
 * which has no `id`. Apollo cannot normalize it, so every write REPLACES the
 * whole object instead of merging fields into it.
 *
 * Two unrelated queries select through that same field with disjoint
 * selection sets: `GetListCoursesWithDC3TemplatesQuery` selects
 * `get_admin_courses_by_organization_template_type` (the course list) and
 * `GetTotalCertificatesToDownloadQuery` selects
 * `get_admin_compute_total_certifies_to_download` (the total). Whichever
 * writes second evicts the other's field from `Query.certificate_template`,
 * so a `cache-first`/`cache-and-network` read of the first one comes back
 * incomplete after the second one runs.
 *
 * `apolloCacheConfig` is the singleton `InMemoryCache` this app's Apollo
 * client is built from (via `@crehana/apollo-client`, wired by the shell).
 * This app does not own client creation, so the policy is registered here at
 * module scope — it must run before the first query result is written.
 */
export const CERTIFICATE_BUILDER_MERGE_POLICIES = {
  CertificateBuilderQuery: {
    merge: true,
  },
};

export function registerCacheTypePolicies() {
  apolloCacheConfig.policies.addTypePolicies(
    CERTIFICATE_BUILDER_MERGE_POLICIES,
  );
}
